import { getMappedValueFromOrderOrItem } from '../../../../../../../../../../util';
import {
  CheckBoxColumn,
  CheckboxItem,
  ResultRowItems,
  ResultRowSubItems,
  ResultsColumn,
} from '../../DTOrderSearchResult.styles';
import Price from '../../../../../../../../../common/Price/Price';
import React, { useContext, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getLineItemsOfSelectedOrder,
  getOrderingSystem,
  getSelectedLineItemsIds,
} from '../../../../../../../../../../selectors/tools';
import get from 'lodash/get';
import {
  setSelectedItem,
  setSelectedNestedSubItems,
} from '../../../../../../../../../../actions/tools/OrdersSearchActions';
import { getSelectedNestedSubItems } from '../../../../../../../../../../extractFromState';
import { CurrencyCodeContext } from '../../CurrencyCodeContext';
import { OrderItemsSettingsContext } from '../OrderItemsSettingsContext';

const RBIItems = (props) => {
  const { handleItemCheckboxClick } = props;

  const orderItemsSettings = useContext(OrderItemsSettingsContext);
  const allSubItemsSelected = Boolean(orderItemsSettings && orderItemsSettings.allSubItemsSelected);

  const dispatch = useDispatch();
  const lineItems = useSelector(getLineItemsOfSelectedOrder);
  const selectedLineItemsIds = useSelector(getSelectedLineItemsIds);
  const orderingSystem = useSelector(getOrderingSystem);
  const selectedNestedSubItems = useSelector(getSelectedNestedSubItems);
  const currencyCode = useContext(CurrencyCodeContext);

  const generateRbiSubitems = (list, itemId, isParentItemChecked) => {
    if (!Array.isArray(list)) {
      return null;
    }

    return list.map((subItem, idx) => {
      const subItemId = getMappedValueFromOrderOrItem(subItem, 'itemId', orderingSystem);
      const uniqueId = `${subItemId}_index_${idx}`;
      const isChecked = isParentItemChecked || get(selectedNestedSubItems, `${itemId}`, []).includes(uniqueId);
      const name = getMappedValueFromOrderOrItem(subItem, 'name', orderingSystem);

      return (
        <ResultRowSubItems key={uniqueId}>
          <CheckboxItem
            type="checkbox"
            onChange={() => handleNestedSubItemSelect(itemId, uniqueId, list.length)}
            checked={isChecked}
            disabled={allSubItemsSelected}
          />
          <ResultsColumn>{name}</ResultsColumn>
        </ResultRowSubItems>
      );
    });
  };

  const handleNestedSubItemSelect = (itemId, subItemId, allSubItemsListLength) => {
    const currentSelectedSubItemsIds = selectedNestedSubItems[itemId] || [];

    const updatedList = currentSelectedSubItemsIds.includes(subItemId)
      ? currentSelectedSubItemsIds.filter((id) => id !== subItemId)
      : [...currentSelectedSubItemsIds, subItemId];

    if (updatedList.length === allSubItemsListLength) {
      // select item if all its children selected
      dispatch(setSelectedItem(itemId, true));
    } else {
      // unselect item if some of its children unselected
      dispatch(setSelectedItem(itemId, false));
    }

    dispatch(setSelectedNestedSubItems(itemId, updatedList));
  };

  return (
    <>
      {lineItems.map((item, idx) => {
        const itemId = getMappedValueFromOrderOrItem(item, 'itemId', orderingSystem);
        const uniqueId = `${itemId}_index_${idx}`;
        const isChecked = allSubItemsSelected || selectedLineItemsIds.indexOf(uniqueId) > -1;
        const price = getMappedValueFromOrderOrItem(item, 'price', orderingSystem);
        const name = getMappedValueFromOrderOrItem(item, 'name', orderingSystem);
        const points = getMappedValueFromOrderOrItem(item, 'points', orderingSystem);

        return (
          <Fragment key={idx}>
            <ResultRowItems key={uniqueId}>
              <CheckBoxColumn>
                <CheckboxItem
                  disabled={allSubItemsSelected}
                  type="checkbox"
                  onChange={(e) => handleItemCheckboxClick(e, uniqueId, item.children)}
                  checked={isChecked}
                />
              </CheckBoxColumn>
              <ResultsColumn>{name}</ResultsColumn>
              <ResultsColumn>
                <Price
                  value={price}
                  isValueSetInCents={String(orderingSystem) === 'custom_rbi'}
                  currencyCode={currencyCode}
                />
                {points && ` - ${points} Loyalty Points`}
              </ResultsColumn>
            </ResultRowItems>
            {generateRbiSubitems(item.children, uniqueId, isChecked, allSubItemsSelected)}
          </Fragment>
        );
      })}
    </>
  );
};

export default RBIItems;
